function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 3,
  width: 16,
  height: 2,
  rx: 0.5,
  fill: "#061220"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.08153 7.57071C5.0385 7.26949 5.27223 7 5.5765 7H18.4235C18.7278 7 18.9615 7.26949 18.9185 7.57071L17.0613 20.5707C17.0261 20.817 16.8152 21 16.5664 21H7.43365C7.18482 21 6.97386 20.817 6.93867 20.5707L5.08153 7.57071Z",
  fill: "#061220"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 15.5,
  y: 16.1562,
  width: 2,
  height: 8,
  rx: 0.5,
  transform: "rotate(135 15.5 16.1562)",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 9.84277,
  y: 17.5723,
  width: 2,
  height: 8,
  rx: 0.5,
  transform: "rotate(-135 9.84277 17.5723)",
  fill: "white"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.81278582.svg";
export { ForwardRef as ReactComponent };